import React from "react";
import { getStandaloneComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const ThemeEditor = React.lazy(() => import("@mediaspace/features/studio/ThemeEditor"));

export const render = getStandaloneComponentRenderer(ThemeEditor);
